export default {
  title: {
    list: "車両設定",
    create: "車両作成",
    edit: "車両編集"
  },
  framesNumber: "車台番号",
  registrationNumber: "車両番号",
  numberPlate: "ナンバープレート",
  digitacoModelNumber: "デジタコ型番",
  fwVersion: "F/Wバージョン",
  status: "ステータス",
  id: "ID",
  managementOffice: "管理会社",
  operationOffice: "運営会社",
  department: "組織",
  deviceId: "デバイスID",
  mileageMeter: "走行距離メーター",
  peripheralEquipment: "周辺機器",
  peripheralEquipmentName:{
    cameraFront: "カメラ1",
    cameraRear: "カメラ2",
    cameraInner: "カメラ3",
    cameraSide: "カメラ4",
    tdsensorCh1: "温度センサー1",
    tdsensorCh2: "温度センサー2",
    tdsensorCh3: "温度センサー3",
    tdsensorCh4: "温度センサー4",
    etc: "ETC",
  },
  updatedAt: "最終更新日",
  updatedBy: "最終更新者",
  edit: "編集",
  confirmationModal: {
    enable: "有効",
    disable: "無効",
    statusConfirm: "車両を{ status }にします。よろしいですか？",
    button: {
    update: "更新"
    },
    targetVehicle: "対象車両： { vehicle }",
  },
  csv: {
    importTitle: "車両の入力",
  },
  errors: {
    getList: "一覧の取得に失敗しました。"
  },
  messages: {
  },
  form: {
    vehicleVerifyImage: "車検証画像データ",
    removeImage: "画像削除",
    vehicleInspectionInformation: "初年度登録",
    mileageMeter: "走行距離メータ",
    digitacoMapping: "デジタコマッピング",
    firmwareSettingCopy: "他のデジタコファームウェアから設定をコピー",
    isDailyReportJobDisabled: "日報生成ジョブ無効化",
    dailyReportJobDisabledAlert: "帰庫した際に日報が自動で生成されません。",
    sim: "SIM",
    accessPoint: "接続先 MQTT",
    iniFileSetting: {
      title: "INIファイル設定",
      messages: {
        update: "INIファイル設定を最新に更新する",
        noLatest: "INIファイル設定が最新ではありません。"
      },
      etc: {
        title: "ETC",
        connect: "ETC連動（ON/OFF）",
        device: "ETC車載器メーカー",
        roadSelect: "一般/高速自動切替（ON/OFF）"
      },
      tdSensor: {
        title: "TDSENSOR",
        ch: "チャンネル",
        ch1: "チャンネル１",
        ch2: "チャンネル２",
        ch3: "チャンネル３",
        ch4: "チャンネル４",
        tdrfSensor: "温度管理(ON/OFF)",
        tdTypeTitle: "接続タイプ(RF無線/WIRED有線)",
        tdTypeRf: "RF(無線)",
        tdTypeWired: "WIRED(有線)",
        chUpper: "チャンネル上限",
        chLower: "チャンネル下限"
      },
      gSensor: {
        title: "GSENSOR",
        acceleration: "加速度設定",
        accelerationForward: "急加速（速度差）",
        accelerationBackward: "急ブレーキ（速度差）",
        accelerationSettingHint: "入力可能範囲: 1.8 ~ 18.0（小数点第1位まで）",
        customValuePrompt: "カスタム値を入力",
        horizontal: "急旋回",
        backward: "急減速",
        forward: "急加速",
      },
      record: {
        cameraFrontOn: "CAMF_ON", // 表示だけ
        cameraFrontPixel: "CAMF_PIXEL",
        cameraFrontBitrate: "CAMF_BITRATE",
        cameraFrontHorizon: "CAMF_H",
        cameraFrontVertical: "CAMF_V",
        cameraFrontFps: "CAMF_FPS",
        soundOn: "SOUND_ON",
        cameraRearOn: "CAMR_ON",
        cameraRearPixel: "CAMR_PIXEL",
        cameraRearBitrate: "CAMR_BITRATE",
        cameraRearFps: "CAMR_FPS",
        cameraRearHorizon: "CAMR_H",
        cameraRearVertical: "CAMR_V",
        cameraInsideOn: "CAMI_ON",
        cameraInsidePixel: "CAMI_PIXEL",
        cameraInsideBitrate: "CAMI_BITRATE",
        cameraInsideFps: "CAMI_FPS",
        cameraInsideHorizon: "CAMI_H",
        cameraInsideVertical: "CAMI_V",
        cameraSideOn: "CAMS_ON",
        cameraSidePixel: "CAMS_PIXEL",
        cameraSideBitrate: "CAMS_BITRATE",
        cameraSideFps: "CAMS_FPS",
        cameraSideHorizon: "CAMS_H",
        cameraSideVertical: "CAMS_V",
        selectPixelFHD: "FHD",
        selectPixelHD: "HD",
        selectPixelSD360: "SD360",
        selectPixelSD480: "SD480",
        selectSoundOnOn: "ON",
        selectSoundOnOff: "OFF",
        selectCameraOnOn: "ON",
        selectCameraOnOff: "OFF",
        selectBitrateHigh: "HIGH",
        selectBitrateMeddle: "MID",
        selectBitrateLow: "LOW",
        selectFps5: "5",
        selectFps10: "10",
        selectFps15: "15",
        selectFps30: "30",
        selectHorizonNormal: "NORMAL",
        selectHorizonMirror: "MIRROR",
        selectVerticalNormal: "NORMAL",
        selectVerticalRotate: "ROTATE",
      },
      speedAlert: {
        title: "SPEED ALERT",
        subtitle: "スピードアラートの設定",
        continuous: "連続",
        fifteenSeconds: "15秒",
        thirtySeconds: "30秒",
        fortyFiveSeconds: "45秒",
        sixtySeconds: "60秒",
        onlyExcess: "超過時のみ (0)",
        continuation: "継続 (1)",
        speedLimitAlert: "速度超過アラート機能",
        alertSpeedSettings: "アラート速度設定",
        expresswaySpeed: "高速道路 { speedLimit } km/hの",
        expresswayKph: "高速道路 (km/h)",
        generalRoadSpeed: "一般道路 { speedLimit } km/hの",
        generalRoadKph: "一般道路 (km/h)",
        preAlertInKph: "km/hの手前 { speed } km/hで事前警告",
        decisionTime: "判定時間",
        decisionTimeSeconds: "判定時間 (秒)",
        alertTiming: "アラートタイミング",
        alertTimingLabel: "アラートタイミング (0=超過時のみ、1=継続)",
        alertInterval: "アラート間隔",
        speedLimitPreAlert: "速度超過事前アラート機能",
        PreAlertSpeedSettings: "事前アラート速度設定"
      },
      pulse: {
        title: "PULSE",
        speedPulse: "車速パルス係数",
        tachoPulse: "エンジン回転係数",
        speedLevel: "スピードレベル（0＝電圧、1＝電流）",
        tachoLevel: "エンジン回転レベル（0＝電圧、1＝電流）",
        speedThreshold: "速度パルスレベル",
        tachoThreshold: "回転パルスレベル",
        tachoLimitNormal: "一般道エンジン回転超過（rpm）",
        tachoLimitHigh: "高速道エンジン回転超過（rpm）"
      },
      common: {
        title: "COMMON",
        allAllow: "ALL_ALLOW = 全て上書き設定",
        allDeny: "ALL_DENY = 全て上書き禁止",
        normalDeny: "NORMAL_DENY = 常時録画上書き禁止",
        eventDeny: "EVENT_DENY = イベント録画上書き禁止",
        digitachoDeny: "DIGITACHO_DENY = デジタコデータ上書き禁止",
        sampleInput: "入力例:",
        ftpOn: "FTPON",
        ftpId: "FTPID",
        ftpPass: "FTPPASS",
        alertIdlingFirstSec: "アイドリング超過時間（秒）：0～9999秒",
        alertIdlingSecondSec: "アイドリング警告繰返時間（秒）：0～9999秒",
        volume: "音量：0～5",
        alertIdlingSound: "アイドリング警告アラート",
        gpsDr: "GPSデットレコニング",
        cameraOn: "CAMERA_ON",
        overwriteDeny: "OVERWRITE_DENY",
        wakeupUpdate: "WAKEUP_UPDATE",
        uploadTripData: "UPLOAD_TRIP_DATA",
        automaticCancellationOn: "作業ボタン自動解除設定",
        automaticCancellationSpeed: "作業ボタン自動解除条件設定(km/h)：1～20",
        automaticCancellationTime: "作業ボタン自動解除条件設定(何秒間継続) : 1~30",
        delayPoweroffOn: "デジタコ電源OFFタイマー設定",
        delayPoweroffTime: "エンジンOFF後の起動時間(分) : 1~30",
        delayPoweroffVoltage: "デジタコ強制終了バッテリー電圧(V) : 10.0~24.0",
        longDriveLabel: "長時間連続運転判定解除条件設定",
        longDriveInterruptionMode: "長時間運転解除モード (A=休憩を含む全ての運転離脱、B=休憩時間のみ)",
        longDriveInterruptionCounterReset: "長時間運転解除カウンタリセット (1=車速検知時、2=作業終了時)",
        selectLongDriveInterruptionModeA: "休憩を含む全ての運転離脱 (A)",
        selectLongDriveInterruptionModeB: "休憩時間のみ (B)",
        selectLongDriveCounterReset1: "車速検知時 (1)",
        selectLongDriveCounterReset2: "作業終了時 (2)",
        selectCameraOnOn: "ON",
        selectCameraOnOff: "OFF",
      },
      subtitles: {
        record: "ドライブレコーダ",
      },
    },
    validate: {
      deviceWithoutModelType: "デジタコマッピングで割り当てたデバイスに型番を入力してください。"
    }
  }
}
